var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlayButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1667 0.5H1.83333C1.09333 0.5 0.5 1.09333 0.5 1.83333V11.1667C0.5 11.9 1.1 12.5 1.83333 12.5H11.1667C11.9 12.5 12.5 11.9 12.5 11.1667V1.83333C12.5 1.09333 11.9 0.5 11.1667 0.5ZM5.16667 9.16667V3.83333L8.5 6.5",
    fill: "#111111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlayButton);
export default __webpack_public_path__ + "static/media/icon-play-button.d4ec3f0ff5c2de3a1b967c71efca96ac.svg";
export { ForwardRef as ReactComponent };